import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RootState, logout } from "../../store";
import RailwayImage from "../../assets/images/Railway.png";
import config from "../../config.json";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export default function Header() {
    const profile = useSelector((state: RootState) => state.account.profile || {});
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const getInitials = (name: string) => {
        if (!name) return "U";
        const nameParts = name.trim().split(" ");
        if (nameParts.length === 1) return nameParts[0][0].toUpperCase();
        return (nameParts[0][0] + nameParts[nameParts.length - 1][0]).toUpperCase();
    };

    const handleLogout = () => {
        dispatch(logout());
        navigate("/sign-in");
    };

    return (
        <header className="flex items-center justify-between w-full min-h-[64px] px-6 bg-white border-b border-gray-200 shadow-sm shrink-0 z-50 relative">
            <div className="flex items-center gap-3">
                <img src={RailwayImage} alt="Logo" className="w-10 h-10" />
                <h2 className="text-xl font-bold m-0 p-0" style={{ color: config.primary_color }}>
                    {config.app_name}
                </h2>
            </div>
            <div className="flex items-center gap-4">
                <DropdownMenu>
                    <DropdownMenuTrigger asChild>
                        <div className="flex items-center gap-2 px-2 py-1 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer select-none outline-none">
                            <div className="flex flex-col items-end mr-2 leading-snug">
                                <span className="text-[11px] font-medium text-gray-400">{profile.designation || "N/A"}</span>
                                <span className="text-sm font-bold text-gray-800">{profile.name || "Guest"}</span>
                            </div>
                            <div className="w-9 h-9 rounded-full bg-gray-100 flex items-center justify-center text-sm font-semibold text-gray-800 border border-gray-200">
                                {getInitials(profile.name || "User")}
                            </div>
                        </div>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent align="end" className="w-44">
                        <DropdownMenuItem onClick={() => navigate("/profile")} className="cursor-pointer gap-2">
                            <i className="fa-regular fa-user text-base" /> Profile
                        </DropdownMenuItem>
                        <DropdownMenuSeparator />
                        <DropdownMenuItem onClick={handleLogout} className="cursor-pointer gap-2 text-red-600 focus:text-red-600">
                            <i className="fa-solid fa-right-from-bracket text-base" /> Logout
                        </DropdownMenuItem>
                    </DropdownMenuContent>
                </DropdownMenu>
            </div>
        </header>
    );
}
